import { Ref, TwinPair, swap } from 'src/util';

type Player = {
  name: string,
  ref: Ref<Player>,
};

function Player(props: { name: string }): Player {
  return { ref: Ref<Player>(), ...props };
}

namespace Player {
  export type Side = 0 | 1;

  type PBase = Ref<Player> | null;

  export type Pair<P extends PBase = PBase> = TwinPair<P>;

  export function Pair<P extends PBase>(
    current: P,
    opponent: P,
    side: Side = 0,
  ): Pair<P> {
    const pair = TwinPair(current, opponent);
    return side === 0 ? pair : swap(pair);
  }

  export namespace Pair {
    export function Current<P extends PBase>(pair: Pair<P>, side: Side) {
      return pair[side];
    }

    export function Opponent<P extends PBase>(pair: Pair<P>, side: Side) {
      return pair[side === 0 ? 1 : 0];
    }
  }
}

export default Player;



// WEBPACK FOOTER //
// ./src/state/Player.ts